import React from "react";
import { Route } from "react-router-dom";
import PrivateRoute from "src/routes/PrivateRoute";
import { CampaignsPage } from "../pages";

export const routes = (
  <Route
    path="/campaigns"
    element={
      <PrivateRoute>
        <CampaignsPage />
      </PrivateRoute>
    }
  />
);
